webpackJsonp([215402269278549],{

/***/ 1757:
/***/ (function(module, exports) {

	module.exports = {"pathContext":{"name":"DetailedSalesRevenueItemEdge","kind":"OBJECT","type":"OBJECT","fields":[{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"cursor","type":{"kind":"SCALAR","name":"String","ofType":null}},{"args":[],"deprecationReason":null,"description":null,"isDeprecated":false,"name":"node","type":{"kind":"OBJECT","name":"DetailedSalesRevenueItem","ofType":null}}],"description":null,"enumValues":null,"possibleTypes":null}}

/***/ })

});


// WEBPACK FOOTER //
// path---object-detailed-sales-revenue-item-edge-cdd0734aa2607cf316d8.js